import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';
import { cn } from '@/shared/utils';
import {
  ACCOUNT_TYPE_ICONS,
  ACCOUNT_TYPE_LABEL_KEYS,
  TRADING_ACCOUNT_TYPES,
  type TradingAccountType,
  type TradingAssetRow,
} from '@/widgets/trading-assets';
import type { TradingSearchGroup } from '../../model';
import { SEARCH_TAB_TRIGGER_CLASSNAME } from '../../config/styles';
import { SearchTradingGroups } from './SearchTradingGroups';

type Props = {
  groups: Array<TradingSearchGroup>;
  baseCode: string;
  onActionRun: () => void;
};

const SearchTradingTabs = ({ groups, baseCode, onActionRun }: Props) => {
  const { t } = useTranslation();
  const [activeType, setActiveType] = useState<TradingAccountType>('spot');

  const activeRows: Array<TradingAssetRow> =
    groups.find(group => group.type === activeType)?.rows ?? [];

  return (
    <div className="flex flex-col gap-[1.6rem]">
      <Tabs
        value={activeType}
        onValueChange={value => setActiveType(value as TradingAccountType)}>
        <TabsList className="bg-transparent gap-[0.2rem] p-0 h-[2.8rem] justify-start">
          {TRADING_ACCOUNT_TYPES.map(type => {
            const Icon = ACCOUNT_TYPE_ICONS[type];

            return (
              <TabsTrigger
                key={type}
                value={type}
                className={cn('cursor-pointer', SEARCH_TAB_TRIGGER_CLASSNAME)}>
                <Icon className="size-[1.6rem] shrink-0" />
                {t(ACCOUNT_TYPE_LABEL_KEYS[type])}
              </TabsTrigger>
            );
          })}
        </TabsList>
      </Tabs>

      <SearchTradingGroups
        groups={
          activeRows.length ? [{ type: activeType, rows: activeRows }] : []
        }
        baseCode={baseCode}
        withTitle={false}
        onActionRun={onActionRun}
      />
    </div>
  );
};

export { SearchTradingTabs };
